import {asyncLoad, asyncPost} from '.';
import {formValidation, handleError} from '../helpers';
import * as alerts from 'actions/alertActions';
import request from '../api/request';

export const loadTicketLogMAPI = ({
  ticketId = -1,
  invoiceId = -1,
}) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Log',
    url: `/TicketLog?ticketid=${ticketId}&combinedinvoiceid=${invoiceId}`,
    params: {useMAPI: true},
  });

export const loadTicketLog = ticketId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Log',
    url: `/Tickets/${ticketId}/log`,
  });

export const loadCombinedInvoiceLog = invoiceId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'Log',
    url: `/invoices/${invoiceId}/log`,
  });

export const addTicketLog = (ticketId, body) => (dispatch, getState) =>
  asyncPost({
    dispatch,
    title: 'Log',
    url: `/Tickets/${ticketId}/log`,
    body: body,
    successMessage: `Successfully saved`,
  });

export const sendSMS = (ticketId, fields, phoneNumbers) => async dispatch => {
  const formObject = formValidation.setupFormBody(fields, false);
  if (formObject.hasError) {
    handleError(formObject.errorMessage, null, dispatch);
    return false;
  }

  const response = await request({
    dispatch,
    method: 'POST',
    title: 'SMS',
    url: `/SMS/Send`,
    body: {
      message: formObject.body.message,
      recipients: phoneNumbers,
      ticketId,
    },
  });

  if (
    response &&
    response.status >= 400 &&
    response.data &&
    response.data.length > 0
  ) {
    response.data.forEach(x => dispatch(alerts.error(x)));
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/actions/logActions.js